import { FunctionComponent, useEffect, useState } from 'react'
import { IWorkroom, IWorkroomMember } from 'Frontend/scripts/models/workrooms.model'
import { useTranslation } from 'react-i18next'
import { Button } from 'react-bootstrap'
import { getWorkroomMembers } from 'Frontend/scripts/services/workrooms.service'
import AssignOwner from './AssignOwner'

interface IWorkroomProps {
  workroom: IWorkroom
  callback: () => void
}

const WorkroomItem: FunctionComponent<IWorkroomProps> = ({ workroom, callback }) => {
  const { t } = useTranslation()
  const [members, setMembers] = useState<IWorkroomMember[]>([])
  const [showMembers, setShowMembers] = useState<boolean>(false)
  const getMembers = () => {
    getWorkroomMembers(workroom.id).then((members) => {
      setMembers(members)
    })
  }

  return (
    <li className="d-flex justify-content-between align-items-center position-relative manage-forums__thread-item gap-2">
      <a className="manage-forums__thread-item-link" href={workroom?.url}>
        {workroom?.name}
      </a>
      <div className="flex-shrink-0">
        {workroom?.isHidden && <span className="badge workrooms__status workrooms__status--small">{t('hidden')}</span>}
        <Button
          variant="link"
          className="py-0"
          onClick={() => {
            getMembers()
            setShowMembers(true)
          }}
        >
          {workroom?.ownerUser ? (
            workroom.ownerUser?.profileImageUrl ? (
              <img
                className="manage-forums__user-profile-image"
                src={workroom.ownerUser.profileImageUrl}
                alt={`${t('image-of')} ${workroom.ownerUser?.firstname} ${workroom.ownerUser?.lastname}`}
                title={`${t('owner')}: ${workroom.ownerUser.firstname} ${workroom.ownerUser.lastname}`}
              />
            ) : (
              <div
                className="manage-forums__user-initial-letters"
                title={`${t('owner')} ${workroom.ownerUser?.firstname} ${workroom.ownerUser?.lastname}`}
              >
                {workroom.ownerUser?.firstname?.charAt(0)}
                {workroom.ownerUser?.lastname?.charAt(0)}
              </div>
            )
          ) : (
            <div className="livstecknet-thread__profile-initial-letters livstecknet-thread__profile-initial-letters--small">
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24">
                <use xlinkHref="#icon-profile" />
              </svg>
            </div>
          )}
        </Button>
      </div>
      <AssignOwner
        isVisible={showMembers}
        workroomId={workroom.id}
        members={members}
        callback={(value: boolean) => {
          setShowMembers(value)
          callback()
        }}
      />
    </li>
  )
}

export default WorkroomItem
